export const REVENUE_MULTIPLIER = 1000000 * 1000;
